import React, { Component } from 'react';

import AppContext from './AppContext';
import stores from './stores';
import authService from '../services/AuthService';

class AppProvider extends Component {
    constructor(props) {
        super(props);
        this.state = {
            stores: stores,
            services: {
                authService: authService
            }
        };
    }

    render() {
        return (
            <AppContext.Provider
                value={{
                    stores: this.state.stores,
                    services: this.state.services
                }}
            >
                {this.props.children}
            </AppContext.Provider>
        );
    }
}

export default AppProvider;